import Tippy from '@tippyjs/react';
import { tv } from 'tailwind-variants';

import { createEnumVariants } from '~/utils/commonTailwindVariants.utils';

export enum ToolTipColor {
  BLACK = 'BLACK'
}

// https://atomiks.github.io/tippyjs/v6/all-props/#placement
export enum TooltipPlacement {
  AUTO = 'auto',
  AUTO_END = 'auto-end',
  AUTO_START = 'auto-start',
  BOTTOM = 'bottom',
  BOTTOM_END = 'bottom-end',
  BOTTOM_START = 'bottom-start',
  LEFT = 'left',
  LEFT_END = 'left-end',
  LEFT_START = 'left-start',
  RIGHT = 'right',
  RIGHT_END = 'right-end',
  RIGHT_START = 'right-start',
  TOP = 'top',
  TOP_END = 'top-end',
  TOP_START = 'top-start'
}
// Base tooltip styles
export const tooltipStyles = tv({
  base: 'font-ibmPlexSans max-w-[250px] whitespace-pre-line rounded-lg px-3 py-2 text-sm',
  variants: {
    color: createEnumVariants<typeof ToolTipColor>({
      [ToolTipColor.BLACK]: 'bg-black text-white'
    })
  }
});

interface ToolTipProps {
  children: React.ReactElement;
  content: string | undefined;
  color?: ToolTipColor;
  disabled?: boolean;
  interactive?: boolean;
  offset?: [number, number];
  onClick?: (() => void) | undefined;
  placement?: TooltipPlacement;
}

const ToolTip: React.FC<ToolTipProps> = ({
  content,
  children,
  disabled = false,
  interactive = false,
  placement = TooltipPlacement.TOP,
  offset = [0, 1],
  onClick,
  color = ToolTipColor.BLACK
}) => {
  // Generate the classes for the tooltip
  const classes = tooltipStyles({ color });

  return (
    <Tippy
      className={classes}
      content={
        onClick ? (
          <div
            className="cursor-pointer hover:opacity-85"
            data-testid="tooltip-clickable-content"
            id="tooltip-clickable-content"
            onClick={onClick}
          >
            {content}
          </div>
        ) : (
          content
        )
      }
      disabled={disabled || !content}
      duration={[null, 0]}
      interactive={interactive}
      offset={offset}
      placement={placement}
    >
      {children}
    </Tippy>
  );
};

export default ToolTip;
